export default __webpack_public_path__ + "static/img-ml-vs-programming-92340fb868726c47f4e0417f64bc9059.png";